
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { collabDto } from "src/app/models/collabDto";
import { ProfilDto } from "src/app/models/ProfilDto";
import { userAddKeycloakDto } from "src/app/models/userAddKeycloakDto";
import { userProfilDto } from "src/app/models/userProfilDto";
import { vendeurExtDto } from "src/app/models/vendeurExtDto";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class collabService {


  PATH_GET_ALL_COLLAB = "/vendeurs/collaborateur/getAllCollaborateurs";
  PATH_UPDATE_ACTIVE_COLLAB = "/vendeurs/collaborateur/update/";
  PATH_ADD_COLLAB = "/vendeurs/collaborateur/addcollab";
  PATH_UPDATE_COLLAB = "/vendeurs/collaborateur/updatecollab";
  PATH_GET_COLLAB_BY_NUMENTITE = "/vendeurs/collaborateur/getCollabsBynumEntite/";
  PATH_GET_COLLAB_PROFIL = "/vendeurs/collaborateur/getProfils";
  PATH_POST_VEXTERNE = "/vendeurs/vendeur-ext/add";
  PATH_GET_COLLABEMAIL = "/vendeurs/collaborateur/getCollbByEmail/";
  PATH_GET_PROFL_BY_CODE = "/vendeurs/collaborateur/getProfilByCode/";




  vendeurExt!: vendeurExtDto;

  constructor(private readonly http: HttpClient) { }


  getcollab = (): Observable<collabDto[]> => {
    const url = environment.host.domaine + this.PATH_GET_ALL_COLLAB

    return this.http.get<collabDto[]>(url);
  }


  setActif(num: number): Observable<collabDto[]> {

    const url = `${environment.host.domaine + this.PATH_UPDATE_ACTIVE_COLLAB + num}/1`;
    return this.http.put<collabDto[]>(url, { headers: Headers, observe: 'response' });


  }


  addCollab(body: any): Observable<any> {

    const url = environment.host.domaine + this.PATH_ADD_COLLAB;
    let headers = new HttpHeaders({ 'accept': '*/*' });
    // let headers = new HttpHeaders({ 'accept': '*/*',});

    const bodytoAdd = {

      "nom": body.nom,
      "prenom": body.prenom,
      "email": body.mail,
      "telgsm": body.telgsm,
      "titre": body.titre,
      "actif": this.convertActif(body.actif),
      "web": "1",
      "societe": body.numEntite.toString(),
      "numPrimpromo": "",
      "user": body.user,
      "user_id": " ",
      "type": " ",
      "metier": "NEUF",
      "profil": body.profil,
      "numEntite": body.numEntite.toString()


    };

    return this.http.post<any>(url, bodytoAdd, { headers: headers })

  }

  updateCollab(body: any): Observable<any> {
    const url = environment.host.domaine + this.PATH_UPDATE_COLLAB;



    const bodytoAdd = {

      "nom": body.nom,
      "prenom": body.prenom,
      "email": body.mail,
      "telgsm": body.telgsm,
      "titre": body.titre,
      "actif": this.convertActif(body.actif),
      "web": "1",
      "societe": body.numEntite.toString(),
      "numPrimpromo": "",
      "user": body.user,
      "user_id": " ",
      "type": " ",
      "metier": "NEUF",
      "profil": body.profil,
      "numEntite": body.numEntite.toString(),
      "numCollab": body.numCollab


    };
    return this.http.put<any>(url, bodytoAdd)

  }


  convertActif(actif: boolean) {
    if (actif == true) { return '1' }
    else return '0';
  }



  getCollabsBynumEntite(numEntite: number): Observable<collabDto[]> {

    const url = environment.host.domaine + this.PATH_GET_COLLAB_BY_NUMENTITE + numEntite;
    // const url ="https://cloud-ide-extrav-realestate.staging.echonet/user/e77868/http/8091/collaborateur/getCollabsBynumEntite/"+numEntite;
    let headers = new HttpHeaders({ 'accept': '*/*' });

    return this.http.get<collabDto[]>(url, { headers: headers });
  }

  getProfils(): Observable<ProfilDto[]> {
    const url = environment.host.domaine + this.PATH_GET_COLLAB_PROFIL

    // const url ="https://cloud-ide-extrav-realestate.staging.echonet/user/e77868/http/8091/collaborateur/getCollabsBynumEntite/"+numEntite;
    // let headers = new HttpHeaders({ 'accept': '*/*'});
    let headers = new HttpHeaders({ 'accept': '*/*' });
    return this.http.get<ProfilDto[]>(url, { headers: headers });

  }

  addCollabExterneToCRMandPIMPFIC(body: any): Observable<any> {
    const url = environment.host.domaine + this.PATH_POST_VEXTERNE

    // let headers = new HttpHeaders({ 'accept': '*/*'});
    let vendeurext: vendeurExtDto = {
      resi_email: '',
      resi_nom: '',
      resi_nomcomplet: '',
      resi_prenom: ''
    }
    vendeurext.resi_email = body.mail;
    vendeurext.resi_nom = body.nom;
    vendeurext.resi_prenom = body.prenom;
    vendeurext.resi_nomcomplet = body.nom + ' ' + body.prenom;
    let headers = new HttpHeaders({ 'accept': '*/*' });

    return this.http.post<vendeurExtDto>(url, vendeurext, { headers: headers });


  }
  getCollabByEmail = (email: string | undefined): Observable<collabDto> => {

    const url = environment.host.domaine + this.PATH_GET_COLLABEMAIL + email;

    const headers = new HttpHeaders({ 'accept': 'application/json' });

    return this.http.get<collabDto>(url, { headers });
  }

  getProfilBya1Code(a1code: number): Observable<ProfilDto> {

    const url = environment.host.domaine + this.PATH_GET_PROFL_BY_CODE + a1code;
    const headers = new HttpHeaders({ 'accept': '*/*' });

    return this.http.get<ProfilDto>(url, { headers: headers });

  }

  //  addCollabToKeyckloakAdmin(userdto: userAddKeycloakDto) : Observable<HttpResponse<any>> {

  //   const url = environment.host.domaine+"/vendeurs/keycloak/admin/";
  //   const headers = new HttpHeaders({ 'accept': 'application/json','Content-Type':'application/json'});

  //   let user :userAddKeycloakDto = {
  //     email:'',
  //     firstName:'',
  //     lastName:'',
  //     enabled:true,
  //     username:''
  //   }

  //   user.firstName = userdto.firstName;
  //   user.lastName  = userdto.lastName;
  //   user.email = userdto.email;
  //   user.enabled  = user.enabled;

  //   return this.http.post<HttpResponse<any>>(url,user,{headers:headers,observe: 'response'});


  //  }
  getUserKeycloak(email: string): Observable<userAddKeycloakDto> {
    const url = environment.host.domaine + "/vendeurs/keycloak/get-user-by-email/" + email;
    const headers = new HttpHeaders({ 'accept': 'application/json', 'Content-Type': 'application/json' });

    return this.http.get<userAddKeycloakDto>(url, { headers });
  }

  restPasswordKeycloak(userid: string): Observable<any> {
    const url = environment.host.domaine + "/vendeurs/keycloak/reset-password/" + userid;
    const headers = new HttpHeaders({ 'accept': 'application/json', 'Content-Type': 'application/json' });

    return this.http.put<any>(url, { headers });
  }

}